import React from 'react'
import { 
  AlertCircle, 
  ArrowRight, 
  Info 
} from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

const SenalesDeAlertaCard = ({ senalesDeAlerta }) => {
  if (!senalesDeAlerta) return null

  const { 
    perdidaApetito, 
    problemasDigestivos 
  } = senalesDeAlerta

  return (
    <Card className="overflow-hidden bg-white">
      {/* Encabezado */}
      <CardHeader className="border-b bg-gradient-to-r from-orange-500/10 to-transparent p-5 sm:p-6">
        <div className="flex items-center gap-3">
          <div className="p-2.5 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl shadow-md">
            <AlertCircle className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
          </div>
          <div>
            <CardTitle className="text-xl sm:text-2xl text-gray-800 font-semibold">
              Señales de Alerta
            </CardTitle>
            <p className="text-base text-gray-500 mt-1">
              Observa estos cambios en tu mascota
            </p>
          </div>
        </div>
      </CardHeader>

      {/* Contenido */}
      <CardContent className="p-4 sm:p-5 space-y-4">
        {/* Pérdida de Apetito */}
        {perdidaApetito && (
          <div className="bg-gradient-to-br from-orange-50 to-white rounded-xl border border-orange-100 overflow-hidden hover:shadow-md transition-all">
            <div className="p-4 space-y-3">
              <div className="flex items-center gap-2">
                <AlertCircle className="h-5 w-5 text-orange-500" />
                <h3 className="text-lg sm:text-xl font-medium text-gray-900">
                  Pérdida de Apetito
                </h3>
              </div>

              {/* Qué observar */}
              {perdidaApetito.queObservar?.length > 0 && (
                <div className="bg-white rounded-lg border border-orange-100 p-3 space-y-2 hover:border-orange-200 transition-all">
                  <div className="flex items-center gap-2 mb-1">
                    <Info className="h-5 w-5 text-orange-500" />
                    <span className="text-base font-medium text-orange-600">
                      Qué Observar
                    </span>
                  </div>
                  {perdidaApetito.queObservar.map((item, idx) => (
                    <div key={idx} className="flex items-start gap-2 bg-orange-50/50 p-2 rounded-lg">
                      <ArrowRight className="h-5 w-5 mt-0.5 text-orange-500 flex-shrink-0" />
                      <p className="text-base text-gray-700">{item}</p>
                    </div>
                  ))}
                </div>
              )}

              {/* Qué hacer */}
              {perdidaApetito.queHacer && (
                <div className="bg-orange-100 rounded-lg border border-orange-200 p-3">
                  <div className="flex items-start gap-2">
                    <AlertCircle className="h-5 w-5 mt-0.5 text-orange-600 flex-shrink-0" />
                    <p className="text-base text-orange-700">
                      {perdidaApetito.queHacer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Problemas Digestivos */}
        {problemasDigestivos && (
          <div className="bg-gradient-to-br from-red-50 to-white rounded-xl border border-red-100 overflow-hidden hover:shadow-md transition-all">
            <div className="p-4 space-y-3">
              <div className="flex items-center gap-2">
                <AlertCircle className="h-5 w-5 text-red-500" />
                <h3 className="text-lg sm:text-xl font-medium text-gray-900">
                  Problemas Digestivos
                </h3>
              </div>

              {/* Señales */}
              {problemasDigestivos.señales?.length > 0 && (
                <div className="bg-white rounded-lg border border-red-100 p-3 space-y-2 hover:border-red-200 transition-all">
                  <div className="flex items-center gap-2 mb-1">
                    <Info className="h-5 w-5 text-red-500" />
                    <span className="text-base font-medium text-red-600">
                      Señales
                    </span>
                  </div>
                  {problemasDigestivos.señales.map((item, idx) => (
                    <div key={idx} className="flex items-start gap-2 bg-red-50/50 p-2 rounded-lg">
                      <ArrowRight className="h-5 w-5 mt-0.5 text-red-500 flex-shrink-0" />
                      <p className="text-base text-gray-700">{item}</p>
                    </div>
                  ))}
                </div>
              )}

              {/* Acción */}
              {problemasDigestivos.accion && (
                <div className="bg-red-100 rounded-lg border border-red-200 p-3">
                  <div className="flex items-start gap-2">
                    <AlertCircle className="h-5 w-5 mt-0.5 text-red-600 flex-shrink-0" />
                    <p className="text-base text-red-700">
                      {problemasDigestivos.accion}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default SenalesDeAlertaCard
